
import { VideoPageComponent } from "../components/videoMain"

export const VideoPage = () => {
    return (
       <VideoPageComponent/>
    )
}